import React from 'react';
import './Overlay.scss';
import Logo from '../../assets/images/Logo.svg';
import XLink from '../../assets/images/X_Link_white.svg';

interface OverlayProps {
  show: boolean;
  message: string;
  buttonText?: string;
  isRefresh?: boolean;
  onClose?: () => void;
}

export function Overlay({ show, message, buttonText, isRefresh = false, onClose }: OverlayProps) {
  if (!show) return null;

  const handleClick = () => {
    if (isRefresh) {
      window.location.reload();
    } else if (onClose) {
      onClose();
    }
  };

  return (
    <div className="overlay">
      <div className="overlay-content">
        <div className="overlay-message">{message}</div>
        {buttonText && (
          <button className="overlay-button" onClick={handleClick}>
            {buttonText}
          </button>
        )}
        <div className="content-footer">
          <img src={Logo} alt="Footer Logo" className="footer-logo" />
          <a href="https://x.com/realTrumpGospel" target="_blank" rel="noopener noreferrer">
            <img src={XLink} alt="X Social Link" className="x-link" />
          </a>
        </div>
      </div>
    </div>
  );
}
